import React, { useEffect, useState } from "react"
import { CheckBox } from "devextreme-react";
import TagBox from "../common/CustomTagBox";
import SelectBox  from "../common/CustomSelectBox";
import DateBox from "../common/CustomDateBox"
import { baseRequest } from "../../fetch/basicThunk";
import { useDispatch } from "react-redux";
import { QUERY_GET_IMPORT_FILE_JOBS, QUERY_GET_IMPORT_FILE_TYPES, QUERY_IMPORT_FILE } from "../../fetch/constantQueries";
import { openModal } from "../../redux/modal/modalSlice";
import { Button, Divider, IconButton, Typography } from "@material-ui/core";
import { useRef } from "react";
import Table from "../table/Table";
import { Column } from "devextreme-react/data-grid";
import CustomPagination from "../table/CustomPagination";
import dayjs from "dayjs";
import importIcon from "../../images/importIcon.svg"
import { ImportStates } from "../../Constantes/ImportState";
import blueIcon from "../../images/circle-blue.svg";
import redIcon from "../../images/iconInactivo.svg";
import greenIcon from "../../images/iconActivo.svg"
import { FileImportDetail } from "./FileImportDetail";


function renderStateCell(row){
    const stateCode = row.data.importStateCode;
    let colorCode = blueIcon;

    switch(stateCode){
        case ImportStates.COMPLETED:
            colorCode = greenIcon;
            break;
        case ImportStates.ONGOING:
            colorCode = blueIcon;
            break;
        case ImportStates.FAILED:
            colorCode = redIcon;
    }
    return <div className='active-column-cell'><img width={20} src={colorCode} title={row.value}/><span>{row.value}</span></div>
}

function FileManagement(){
    const [selectedMaster, setSelectedMaster] = useState();
    const [selectedFile, setSelectedFile] = useState()
    const dispatch = useDispatch();
    const inputRef = useRef();
    const [avaliableMasterValues, setAvaliableMasterValues] = useState()
    const [tablePageValues, setTablePageValues] = useState(
        {
            pageIndex: 1,
            totalRecords: 0,
            totalPages: 0,
            pageSize: 10,
            fileMasterTypes: [],
            startDate: dayjs().subtract(2, "month").toDate(),
            sortByField: "id",
            orderByAscending: false,
            showAll: false
        }
    )
    const [importJobs, setImportJobs] = useState([]);
    const [loadingImportJobs, setLoadingImportJobs] = useState("idle")
    const [importJobDetail, setImportJobDetail] = useState()
    const dialogDetailOpen = Boolean(importJobDetail);

    const tableColumns = [
        <Column key={"fileimport-1"} width={"170px"} dataType={"datetime"} dataField={"startDate"} caption="Data" />,
        <Column key={"fileimport-2"} width={"150px"} dataField={"importType"} caption="Tipo Mestre" />,
        <Column key={"fileimport-3"} dataField={"fileName"} caption="Nome do arquivo" />,
        <Column key={"fileimport-4"} width={"200px"} dataField={"importState"} cellRender={renderStateCell} caption="Estado" />,
        <Column key={"fileimport-5"} dataField={"errorMessage"} caption="Mensagem" />,
        <Column key={"fileimport-6"} width={"150px"} dataField={"isCRMImport"} caption="Tipo Importação" calculateSortValue={"isCRMImport"} calculateCellValue={(rowData)=> rowData.isCRMImport? "Manual" : "Automática"}/>,
        <Column key={"fileimport-7"} alignment={"center"} width={"100px"} caption={"Detalhe"} cellRender={(row)=>{
            return isDetailButtonVisible(row.data) ? <IconButton onClick={()=>openDetailDialog(row.data)} size="small"><i className="icon icon-detail icon-black"/></IconButton> : <div></div>
        }}/>
    ]

    function isDetailButtonVisible(row){
        if(row){
            const completedJob = row.importStateCode === ImportStates.COMPLETED
            const showDetail = row.allowDetail
            return completedJob && showDetail
        }
        return false
    }

    useEffect(()=>{
        baseRequest(null, dispatch, QUERY_GET_IMPORT_FILE_TYPES , "GET").then(
            (data)=> setAvaliableMasterValues(data)
        )
        getImportJobs(tablePageValues)

    },[])

    function getImportJobs(values){
        setLoadingImportJobs("loading")
        baseRequest({query: `?pageNum=${values.pageSize}&pageIndex=${values.pageIndex-1}&startDate=${dayjs(values.startDate).format("YYYY-MM-DD")}&fileMasterTypes=${values.fileMasterTypes.join()}&orderByAscending=${values.orderByAscending}&orderByField=${values.sortByField}&showAll=${values.showAll}`}, dispatch, QUERY_GET_IMPORT_FILE_JOBS, "GET" ).then(
            (data)=>  {
                setImportJobs(data.elements);
                setTablePageValues(prevState=>({...prevState, totalRecords: data.totalRecords, totalPages: data.totalPages}))
                setLoadingImportJobs("succeeded");
            }
        ).catch(
            (error)=> {
                setLoadingImportJobs("failed");
                dispatch(openModal({type:"warning", message: "No se ha podido cargar el histórico de importanciones"}))
            }
        )
    }


    function handleSubmit()
    {
        if(!validateSubmitData())
                return;

        let submitData = new FormData();
        submitData.append(`file`, selectedFile)

        baseRequest({body: submitData, param: selectedMaster, excludeContentType: true}, dispatch, QUERY_IMPORT_FILE, "POST").then(
            (data)=> {
                    handleRefresh()
                    dispatch(openModal({type: "success", message: "Importação finalizada com éxito"}));
            },
            (error)=>{handleRefresh()}).catch(
                ()=> handleRefresh()
            )

        setSelectedFile(null);
        setSelectedMaster(null);
        inputRef.current.files = null;
        inputRef.current.value = [];
    }

    function handleLoadFile(e){

        if(e.target.files.length > 0){
            const file = e.target.files[0];
            const isExcelFile = file.name.endsWith(".xlsx") || file.name.endsWith(".xls")
            if(!isExcelFile){
                e.target.files = null
                dispatch(openModal({type: "warning", message: "El formato de arquivo no es válido"}))
                return
            }
            setSelectedFile(e.target.files[0])
        } else {
            setSelectedFile(null)
        }

    }

    function validateSubmitData()
    {
        if(!selectedFile){
                dispatch(openModal({type: "warning", message: "No se ha cargado ningún arquivo"}))
                return false;
            }
        if(!selectedMaster){
                dispatch(openModal({type: "warning", message: "El campo Tipo Maestro es obligatorio"}))
                return false;
        }
        return true;
    }

    function handlePageSizeChange(value){
        getImportJobs({...tablePageValues, pageSize: value})
        setTablePageValues(prevState=>({...prevState, pageSize: value}))
    }

    const handlePageIndexChange = (event, value) => {
        getImportJobs({...tablePageValues, pageIndex: value})
        setTablePageValues(prevState=>({...prevState, pageIndex: value}))
    };

    function handleRefresh(){
        getImportJobs(tablePageValues)
    }

    function setTypeMasterFilters(value){
        const masterTypes = value.length > 0 ? value : [];
        setTablePageValues(prevState=>({...prevState, fileMasterTypes: masterTypes}))

    }

    function handleCellClick (e) {
        if (e.rowType == "header" && (e.column.type !== "selection" && e.column.type !== "buttons")) {
            let columna = e.column.dataField;
            let sortOrder = e.column.sortOrder;
            if (sortOrder == undefined || sortOrder == "undefined") {
                e.column.sortOrder = 'asc';
            }
            else if (sortOrder == 'desc') {
                e.column.sortOrder = 'asc';
            }
    
            else if (sortOrder == 'asc') {
                e.column.sortOrder = 'desc';
            }
            let orden = e.column.sortOrder == 'asc' ? true : false;
            getImportJobs({...tablePageValues, sortByField: columna, orderByAscending: orden})
            setTablePageValues(prevState=>({...prevState, sortByField: columna, orderByAscending: orden}))
        }   
    }

    function openDetailDialog(rowData){
        setImportJobDetail(rowData)
    }

    return(
        <>
        <div style={{margin: "0.5rem"}}>
                <div>
                    <div style={{display: "flex", justifyContent: "center", margin: "0.75rem 0"}}><Typography><span style={{fontWeight: 700}}>Importação de arquivos</span></Typography></div>
                    <div className="import-wrapper">
                    <SelectBox
                        name = "masterName"
                        noDataText="Loading tipos"
                        dataSource = { avaliableMasterValues }
                        value = { selectedMaster}
                        displayExpr = { "keyword" }
                        valueExpr = { "keyword" }
                        onValueChanged = { (e) => setSelectedMaster(e.value) }
                        label="Tipo mestre"
                    >
                    </SelectBox>
                    <div>   
                    <label className="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary" to={"fileUpload"} >
                        <input ref={inputRef} accept=".xls,.xlsx" onChange={handleLoadFile} style={{display: "none"}} id="fileUpload" type={"file"}/>
                        <div className="MuiButton-label" style={{display: "flex", alignItems: "center", columnGap: "4px"}}>
                            <i className="icon icon-add-document icon-button"></i> <span>Selecionar arquivo</span>
                        </div>
                    </label>
                    </div>
                    <span style={{fontSize: "0.75rem"}}>{selectedFile && selectedFile.name}</span>
                    <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Button startIcon={<i className="icon icon-import"/>} variant="contained" color="primary" onClick={handleSubmit}>Importar arquivo</Button>
                    </div>
                    </div>             
                        <ol style={{fontSize:"0.75rem", padding: 0, margin: 14}}>
                            <li>Seleccionar tipo de maestro y arquivo a importar</li>
                            <li>Pulsar botón "Importar arquivo"</li>
                            <li>Cuando el fichero se haya importado, se mostrará el resultado en el histórico de Importações</li>
                        </ol>
                </div>
                    <div style={{marginTop: "1.25rem", marginBottom: "1.25rem", }}>
                        <Divider orientation="horizontal" style={{width: "100%"}}/>
                    </div>
                    <div style={{}}>
                        <div style={{display: "flex", justifyContent: "center", margin: "0.75rem 0"}}><Typography><span style={{fontWeight: 700}}>Histórico de Importações</span></Typography></div>
                        <div style={{display: "grid", gridTemplateColumns: "20% 20% 1fr auto", alignItems: "center", columnGap: "0.75rem", margin: "1rem 0"}}>
                            <DateBox 
                                value={tablePageValues.startDate}
                                onValueChanged={(e)=> setTablePageValues(prevState=>({...prevState, startDate: e.value}))}
                                showDropDownButton
                                label="Data início"
                            >
                            </DateBox>
                            <TagBox
                                name = "masterFilter"
                                showSelectionControls
                                multiline={false}
                                showClearButton
                                selectAllText="Selecionar todos"
                                noDataText="Loading tipos"
                                dataSource = {avaliableMasterValues}
                                defaultValue = {tablePageValues.fileMasterTypes}
                                displayExpr = { "keyword" }
                                valueExpr = { "id" }
                                onValueChanged = { (e) => setTypeMasterFilters(e.value) }
                                label="Tipo mestre"
                            >
                            </TagBox>
                            <div style={{display: "flex", alignItems: "center", columnGap: "6px"}}>
                                <CheckBox 
                                     name = "showAll"
                                     value = { tablePageValues.showAll }
                                     onValueChanged = { (e) => setTablePageValues(prevState=>({...prevState, showAll:e.value})) }
                                 >
                                 </CheckBox>
                                <div style={{fontSize: "0.75rem"}}>
                                     Mostrar Importações automáticas
                                </div>
                            </div>
                            <div>
                                <Button variant="contained" color="primary" onClick={()=>handleRefresh()}>Aplicar filtros</Button>
                            </div>
                        </div>
                        <Table
                            datasource={importJobs}
                            loading={loadingImportJobs} 
                            columnasTabla={tableColumns}   
                            handleCellClick={handleCellClick}
                        />
                        <CustomPagination numElements={[10, 50, 100]} refreshPage={handleRefresh} style={{position: "absolute"}} loading={loadingImportJobs} count={tablePageValues.totalRecords} pageSize={tablePageValues.pageSize} pageIndex={tablePageValues.pageIndex} totalPages={tablePageValues.totalPages} handlePageSizeChange={handlePageSizeChange} handlePageIndexChange={handlePageIndexChange} />
                    </div>
        </div>
        <FileImportDetail key={importJobDetail} open={dialogDetailOpen} data={importJobDetail} closeFunction={()=>setImportJobDetail(false)}/>
        </>

    )
}

export {FileManagement}